module.exports = __webpack_public_path__ + "img/symbol_7.4616d98c.png";